/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Afterpay visibility toggle based on variant price
  document.querySelectorAll('[data-section-type="product-template"]').forEach(function(section) {
    if (section.dataset.afterpayMinEnabled !== 'true') return;
    
    var minPrice = parseInt(section.dataset.afterpayMinPrice, 10) || 3000;
    
    section.addEventListener('theme:variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        section.classList.toggle('afterpay-hidden', e.detail.variant.price < minPrice);
      }
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
